import React, { ReactNode } from 'react';
import { PageType } from '../../../types/api/PageType';
import { PageLeadDescription } from './partials/PageLeadDescription';
import { PageLeadMetaInfo } from './partials/PageLeadMetaInfo';
import { PageLeadPageTypeTranslation } from './partials/PageLeadPageTypeTranslation';
import { PageLead } from './partials/PageLead';
import { PageLeadHeadline } from './partials/PageLeadHeadline';
import { PageLeadSkipLinks } from './partials/PageLeadSkipLinks';
import { PageLeadPageTypeDefinition } from './partials/PageLeadPageTypeDefinition';

export type PageLeadDefault = {
  title: string;
  categories?: string[];
  leadText?: ReactNode;
  invisible?: boolean;
  pageType?: PageType;
};

/**
 * Returns the header element of the document.
 * This element can be invisible in some cases: home page, search pages.
 * This element can be invisible and lacking page lead text: edit mode of pageLead.
 */
export function PageLeadDefault({ title, leadText, pageType, invisible = false, categories = [] }: PageLeadDefault) {
  return (
    <>
      <PageLead modifier={invisible ? 'invisible' : undefined}>
        {pageType && (
          <PageLeadDescription aria-hidden="true">
            <PageLeadPageTypeTranslation pageType={pageType} categories={categories} />
          </PageLeadDescription>
        )}
        <PageLeadHeadline>
          {title}
          <PageLeadMetaInfo />
        </PageLeadHeadline>
        {pageType && (
          <PageLeadPageTypeDefinition>
            <PageLeadPageTypeTranslation pageType={pageType} categories={categories} />
          </PageLeadPageTypeDefinition>
        )}
        {leadText && <p className="page-lead__subheadline">{leadText}</p>}
      </PageLead>
      <PageLeadSkipLinks />
    </>
  );
}
